import { useEffect, useState } from "react";
import client from "@/lib/api";

// Shared live shop-status store: one batched poll for every visible shop pill/profile.
const POLL_MS = 10000;
const store = new Map();
const subs = new Map();
let timer = null;

const emit = (id) => (subs.get(id) || []).forEach((fn) => fn(store.get(id)));

export const publishShopStatus = (id, status) => { if (!id || !status) return; store.set(id, status); emit(id); };

async function poll() {
  const ids = [...subs.keys()].filter((k) => (subs.get(k) || []).length);
  if (!ids.length || document.visibilityState === "hidden") return;
  try {
    const { data } = await client.get("/shop-status", { params: { ids: ids.slice(0, 60).join(",") } });
    Object.entries(data || {}).forEach(([id, st]) => {
      const prev = store.get(id);
      if (!prev || prev.is_open !== st.is_open || prev.label !== st.label) publishShopStatus(id, st);
    });
  } catch { /* transient network error: keep last status, next poll retries */ }
}

function ensureTimer() {
  if (timer) return;
  timer = setInterval(poll, POLL_MS);
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && poll());
  window.addEventListener("focus", poll);
}

export function useLiveShopStatus(shopId, initial) {
  const [status, setStatus] = useState(() => store.get(shopId) || initial);
  useEffect(() => { if (initial && !store.has(shopId)) setStatus(initial); }, [initial, shopId]);
  useEffect(() => {
    if (!shopId) return undefined;
    const fn = (st) => setStatus(st);
    subs.set(shopId, [...(subs.get(shopId) || []), fn]);
    if (store.has(shopId)) setStatus(store.get(shopId));
    ensureTimer();
    return () => subs.set(shopId, (subs.get(shopId) || []).filter((f) => f !== fn));
  }, [shopId]);
  return status;
}
